var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.getClassByType(),on:{"click":function($event){return _vm.click(_vm.objectData)}}},[_c('img',{attrs:{"src":require('@/assets/action/' + _vm.icon)}})])}
var staticRenderFns = []

export { render, staticRenderFns }